import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {first, take} from 'rxjs';
import {AnimalSheltersRepository} from "../../../shared/states/animal-shelter.repository";
import {UserRepository} from "../../../modules/user/states/user.repository";
import {AnimalRepository} from 'src/app/modules/animals/states/animal.repository';
import {Router} from '@angular/router';
import {AnimalShelterModel} from "../../../shared/models/animal-shelter.model";
import {DashboardLoadingService} from 'src/app/shared/services/dashboard-loading.service';

@Component({
  selector: 'app-client-switcher',
  templateUrl: './client-switcher.component.html',
  standalone: false
})
export class ClientSwitcherComponent implements OnInit {
  shelters: AnimalShelterModel[] = [];
  selectedShelter: AnimalShelterModel = {} as AnimalShelterModel

  constructor(
    private readonly _animalShelterRepository: AnimalSheltersRepository,
    private readonly _userRepository: UserRepository,
    private readonly _animalRepository: AnimalRepository,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _router: Router,
    private readonly _dashboardLoadingService: DashboardLoadingService // <--- hinzugefügt
  ) {
    //silence is golden
  }


  ngOnInit() {
    this._animalShelterRepository.getAnimalShelters().pipe(
      first(shelters => shelters.length > 0)
    ).subscribe(shelters => {
      this.shelters = shelters;
      this._userRepository.getActiveUser().pipe(take(1)).subscribe(user => {
        if (user && user.defaultAnimalShelter !== null) {
          const foundShelter = shelters.find(shelter => shelter.id === user.defaultAnimalShelter?.id);
          if (foundShelter) {
            this.selectedShelter = foundShelter;
          }
          this._cdr.detectChanges();
        }
      });
    });
  }

  onShelterChange($event: any) {
    const animalShelter: AnimalShelterModel = $event.value;
    this._animalShelterRepository.setActiveAnimalShelter(animalShelter);

    this._router.navigate(['/home']).then(() => {
      this._dashboardLoadingService.setLoading(true);
    });

    this._animalRepository.getByShelter(animalShelter.id).subscribe({
      complete: () => this._dashboardLoadingService.setLoading(false),
      error: () => this._dashboardLoadingService.setLoading(false)
    });

    this._userRepository.getActiveUser().pipe(take(1)).subscribe(user => {
      if (user !== undefined) {
        this._userRepository.updateUser(user.id, {
          defaultAnimalShelter: {id: $event.value.id}
        });
      }
    });
  }
}
